module.exports = __webpack_public_path__ + "static/media/carousel19.21afa459.jpg";